import React from 'react';
import Footer from '../Footer';

const AdminFooter: React.FC = () => {
  return <Footer />;
};

export default AdminFooter;
